import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import {  useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader'; 
import logo from '../assets/images/logo.png'; 


const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoader, setIsLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  

useEffect(() => {
    const isAuthenticated = AuthService.getCurrentUser(); // Check if the user is authenticated
    if (isAuthenticated) {
        navigate('/dashboard'); // Redirect to dashboard if authenticated
    }
}, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    
    try {
      const data = await AuthService.login(username, password);
      if (data && data.status) {
        toast.success(data.message);
        let user = data.data.user;
        user.auth_token = data.data.auth_token;
        if (user.role && typeof user.role === 'object') {
          user.role = user.role.name;
        }
        localStorage.setItem('user', JSON.stringify(user));
        await AuthService.fetchMyPermissions();
        window.location.href=process.env.REACT_APP_BASE_PATH+'/dashboard';
        // navigate('/dashboard');
      } else {
        toast.error(data?.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="page-body-wrapper full-page-wrapper bg-light">
      <div className="row w-100 m-0 full-page-wrapper">
        <div className="content-wrapper full-page-wrapper d-flex align-items-center auth">
          <div className="col-lg-4 mx-auto">
            <div className="text-center bg-base">
              <img alt="Logo" src={logo} className="w-175px my-2" />
            </div>
            <div className="card">
              <div className="card-body px-5 py-5">
                <div className="text-center my-3">
                  <h3 className="card-title mb-0 fs-2"> Login</h3>
                  <p>Welcome back! login to your account</p>
                </div>
                <br />

                <form onSubmit={handleLogin}>
                  <div className="form-group my-5">
                    <label>Username *</label>
                    <input
                      type="text"
                      required
                      autoComplete="off"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="form-control p_input"
                      placeholder="Username"
                    />
                  </div>

                  <div className="form-group my-5">
                    <label>Password *</label>
                    <div className="input-group" id="show_hide_password">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-control p_input"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        autoComplete="off"
                      />
                      <div className="input-group-addon bg-light border px-3 py-3">
                        <button type="button" className='btn btn-transparent p-0' onClick={() => setShowPassword(!showPassword)}>
                          <i
                            className={`text-dark fs-5  ${showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}`}
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="form-group d-flex align-items-center justify-content-between">
                    <div className="form-check">
                      <label className="form-check-label">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ opacity: 1 }}
                        />
                        Remember Me
                      </label>
                    </div>
                  </div>

                  <div className="text-center my-5">
                    <button
                      type="submit"
                      disabled={isLoader}
                      className="btn btn-base w-100 btn-block"
                    >
                      <span  hidden={isLoader}>
                        Sign In
                      </span>
                      {isLoader && <Loader size="20" text="Signing" color="black" />}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
